var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "row bg-light-grey mx-0 upgrades-box" }, [
        _c("div", { staticClass: "col-xl-9" }, [
          _c(
            "ul",
            {
              staticClass: "nav nav-tabs d-md-flex",
              attrs: { role: "tablist" },
            },
            _vm._l(_vm.upgrades, function (headline, index) {
              return _c(
                "li",
                { staticClass: "nav-item flex-sm-fill text-center" },
                [
                  _c(
                    "a",
                    {
                      class: { active: index == 0 },
                      attrs: {
                        "data-toggle": "tab",
                        href: "#tab" + index,
                        role: "tab",
                      },
                    },
                    [_vm._v(_vm._s(headline.name))]
                  ),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tab-content overflow-hidden" },
            _vm._l(_vm.upgrades, function (content, index) {
              return _c(
                "div",
                {
                  staticClass: "tab-pane overflow-hidden",
                  class: { active: index == 0 },
                  attrs: { role: "tabpanel", id: "tab" + index },
                },
                _vm._l(content.group.groups, function (group, index) {
                  return _c("div", { staticClass: "m-pane" }, [
                    _c("div", { staticClass: "h3 mt-3" }, [
                      _vm._v(_vm._s(group.name)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "list-unstyled single-upgrade" },
                      _vm._l(group.items, function (item) {
                        return _c(
                          "li",
                          {
                            staticClass: "d-flex mt-4 position-relative",
                            class: { active: item.active },
                            on: {
                              click: function ($event) {
                                return _vm.addToGroup(
                                  item,
                                  group.select,
                                  content.group.select,
                                  content
                                )
                              },
                            },
                          },
                          [
                            _c("div", [_vm._v(_vm._s(item.data.texts.name3))]),
                            _vm._v(" "),
                            _c("div", { staticClass: "flex-fill" }, [
                              _vm._v(_vm._s(item.data.texts.name1)),
                            ]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href:
                                    "/" +
                                    item.data.texts.urlPath +
                                    "/a-" +
                                    item.data.item.id,
                                },
                              },
                              [_vm._v("Details")]
                            ),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  item.data.prices.default.unitPrice.formatted
                                )
                              ),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ])
                }),
                0
              )
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xl-3" }, [
          _c("div", { staticClass: "upgrades" }, [
            _c("div", { staticClass: "heading" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$translate("Servershop5::Template.upgradeAuswahl")
                  ) +
                  "\n          "
              ),
            ]),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "list-unstyled mb-0" },
              [
                _c("li", { staticClass: "font-weight-bold" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.iteminfo.texts.name1) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _vm._l(_vm.current, function (section) {
                  return _c("li", [
                    _c("p", { domProps: { innerHTML: _vm._s(section.name) } }),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "list-unstyled" },
                      _vm._l(section.items, function (items) {
                        return _c("li", { staticClass: "font-weight-bold" }, [
                          _vm._v(
                            "\n                  " +
                              _vm._s(items.data.texts.name1) +
                              "\n                "
                          ),
                        ])
                      }),
                      0
                    ),
                  ])
                }),
                _vm._v(" "),
                _c("li", [
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.$translate("Servershop5::Template.pricewithupdates")
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "list-unstyled" }, [
                    _c("li", [
                      _c(
                        "div",
                        { staticClass: "font-weight-bold upgadePrice" },
                        [_vm._v(_vm._s(_vm._f("currency")(_vm.upgradesPrice)))]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "upgradeVat" }),
                    ]),
                  ]),
                ]),
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "heading" }, [
              _c("label", { staticClass: "d-flex align-items-center" }, [
                _c("span", { staticClass: "flex-fill d-none d-lg-flex" }, [
                  _vm._v(
                    " " + _vm._s(_vm.$translate("Servershop5::Template.menge"))
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex qty-wrapper" }, [
                  _c(
                    "button",
                    {
                      staticClass: "qty-btn minus",
                      on: {
                        click: function ($event) {
                          return _vm.changeQuantity("minus")
                        },
                      },
                    },
                    [_vm._v("-")]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.quantity,
                        expression: "quantity",
                      },
                    ],
                    staticClass: "flex-fill",
                    attrs: { type: "number" },
                    domProps: { value: _vm.quantity },
                    on: {
                      change: function ($event) {
                        return _vm.changeQuantityInput()
                      },
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.quantity = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "qty-btn plus",
                      on: {
                        click: function ($event) {
                          return _vm.changeQuantity("plus")
                        },
                      },
                    },
                    [_vm._v("+")]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary btn-block mt-3 pa-0 row",
                  staticStyle: { "font-size": "0.9rem" },
                  on: {
                    click: function ($event) {
                      return _vm.intoBasket()
                    },
                  },
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "\n                                     " +
                        _vm._s(
                          _vm.$translate(
                            "Servershop5::Template.toBasketWithUpgrade"
                          )
                        ) +
                        "\n                              "
                    ),
                  ]),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "mr-2" }, [
      _c("i", { staticClass: "icon-cart-1 p" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }